class VwVezneMakbuzIzlemeDTO {
    id?: number = null;
    adi?: string = "";
    vezneId?: string = "";
    odemeTipad?: string = "";
    odemeTipId?: string = "";
    yil?: number = null;
    tarih?: string = null;
    tutar?: number = null;
    iadetutar?: number = null;
    kasamevcudu?: number = null;
    yazarkasatutar?: number = null;
    makbuzsayi?: number = null;
    tarihsaat?: string = null;
    //SearchModel
    tarih2?: string = null;
}
export default VwVezneMakbuzIzlemeDTO;